import { render, staticRenderFns } from "./DialogForgotPassword.vue?vue&type=template&id=042cf76f&scoped=true&"
import script from "./DialogForgotPassword.vue?vue&type=script&lang=js&"
export * from "./DialogForgotPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042cf76f",
  null
  
)

export default component.exports